import React, { useState } from "react"
import { CGButton } from "./CGButton"
import { H2, P, TextBlock } from "@cd2/text"
import { Modal } from "@cd2/components"

export function ContactUsButton({ children = "Contact us" }: { children?: React.ReactNode }) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <React.Fragment>
      <CGButton onClick={() => setModalOpen(true)}>{children}</CGButton>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        render={() => (
          <TextBlock align="center">
            <H2>Get in Touch</H2>
            <P>BraveGoose Ltd, Faiers House, Gilray Road, Diss IP22 4WR</P>
            <P>
              <a href="mailto:lisa@bravegoose.co.uk" rel="noreferrer noopener">
                lisa@bravegoose.co.uk
              </a>
              <span> / </span>
              <a href="mailto:cj@bravegoose.co.uk" rel="noreferrer noopener">
                cj@bravegoose.co.uk
              </a>
            </P>
            <P>
              <a href="tel:07916 178844" rel="noreferrer noopener">
                07916 178844
              </a>
              <span> (Lisa) / </span>
              <a href="tel:07500 843401" rel="noreferrer noopener">
                07500 843401
              </a>
              <span> (CJ)</span>
            </P>
          </TextBlock>
        )}
      />
    </React.Fragment>
  )
}
